import { TranscriptorEncounterResponse } from '@/shared/api/transcriptor/transcriptorApi';

export const getCallerName = (encounter: TranscriptorEncounterResponse) => {
  const info = encounter.patient_info;
  const fullName = info?.full_name?.trim();

  if (fullName) {
    return fullName;
  }

  const composed = [info?.first_name, info?.last_name]
    .map((namePart) => namePart?.trim())
    .filter(Boolean)
    .join(' ');

  return composed || '—';
};
